import mitt from 'mitt';

export const uploadEvents = mitt();